import { overallScoreAttribute } from "./config";

export const mapCompetenceSummaryData = (data) => {
    const allAttributes = [];
    const existingAttributes = new Set();
    Object.values(data).forEach(user =>
        user.items.forEach(item => {
            if (!existingAttributes.has(item.attribute)) {
                allAttributes.push({ attribute: item.attribute, attribute_title: item.attribute_title || item.attribute })
                existingAttributes.add(item.attribute);
            }
        })
    );
    allAttributes.sort((a, b) => {
        if (a.attribute === overallScoreAttribute) return -1;
        if (b.attribute === overallScoreAttribute) return 1;
        return 0;
    });

    const result = {};

    for (const attr of allAttributes) {
        result[attr.attribute] = {
            'attribute_title': attr.attribute_title || attr.attribute,
            'items': Object.entries(data).map(([userId, user]) => {
                const item = user.items.find(i => i.attribute === attr.attribute);
                return {
                    ...item,
                    user_id: userId,
                    score: item?.score ?? null,
                    score_type: item?.score_type ?? null
                };
            })
        };
    }

    return result;
};

export const mapIndividualSummaryData = (items = []) => {
    let overallScore = {};
    const otherScores = [];
    items.forEach((item) => {
        if (item.attribute === overallScoreAttribute) {
            overallScore = item;
        } else {
            otherScores.push(item);
        }
    });
    // first item will be overall score
    return [overallScore, ...otherScores]
};

export const mapAttributesList = (attributes) => {
    const mappedAttributes = {};
    Object.keys(attributes).forEach((dataSource) => {
        attributes[dataSource].forEach(({ value, text }) => {
            mappedAttributes[`${dataSource}:${value}`] = text;
        });
    });
    return mappedAttributes;
};

export const mapRatingOptionsWrapper = (ratingScales) => {
    const mappedScores = Object.entries(ratingScales).reduce((acc, [type, { options }]) => {
        options.forEach(({ score, ...rest }) => {
            acc[`${type}:${score}`] = { ...rest };
        });
        return acc;
    }, {});
    return (score_type, score) => mappedScores[`${score_type}:${score}`] || {};
};

export const getFilteredSteps = (steps, evaluationCriteria) => {
    const evaluationSteps = new Set(evaluationCriteria.map(({ step_id }) => step_id));
    return steps.filter(({ id }) => evaluationSteps.has(id));
};

export const createConfig = (response) => {
    return {
        ratingScales: response.rating_scales,
        getScoreOption: mapRatingOptionsWrapper(response.rating_scales),
        sections: response.sections,
        overallScoreAttribute: response.overall_step_score_attribute,
    };
};
